/**
 * GroupPrivacyModal — public/private chooser for the create-group form
 * (mobile PrivacyInfo parity).
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { GROUP_PRIVACY } from '@wlb/shared/constants';
import { GlobeIcon, LockIcon } from '../../components/ui/icons';
import { Modal } from '../../components/ui/Modal';
import './groups.css';

const OPTIONS = [
  {
    key: GROUP_PRIVACY.PUBLIC,
    Icon: GlobeIcon,
    titleKey: 'home.privacyInfo.group.publicTitle',
    descKey: 'home.privacyInfo.group.publicDesc',
  },
  {
    key: GROUP_PRIVACY.PRIVATE,
    Icon: LockIcon,
    titleKey: 'home.privacyInfo.group.privateTitle',
    descKey: 'home.privacyInfo.group.privateDesc',
  },
];

interface GroupPrivacyModalProps {
  selected: string;
  onClose: () => void;
  onSelect: (value: string) => void;
}

export function GroupPrivacyModal({ selected, onClose, onSelect }: GroupPrivacyModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('home.privacyInfo.group.title')}
      onClose={onClose}
      labelledBy="group-privacy-modal-title"
    >
      <div className="create-group__privacy" role="radiogroup" aria-labelledby="group-privacy-modal-title">
        {OPTIONS.map(({ key, Icon, titleKey, descKey }) => {
          const isActive = selected === key;
          return (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={isActive}
              className={`create-group__privacy-option${isActive ? ' create-group__privacy-option--active' : ''}`}
              onClick={() => { onSelect(key); onClose(); }}
            >
              <Icon size={20} className="create-group__privacy-icon" />
              <span>
                <span className="create-group__privacy-title">{t(titleKey)}</span>
                <span className="create-group__privacy-desc">{t(descKey)}</span>
              </span>
            </button>
          );
        })}
      </div>
    </Modal>
  );
}
